<app-header [hideBackButton]="true"></app-header>
<ion-content>
  <div class="become-a-customer-buttons" *ngIf="isGuestUser">
    <ion-button
      *ngIf="isGuestUser"
      class="usf-fill-green-dsktp-tblt-modal-button become-a-customer-more-page-button"
      data-cy="become-a-customer-more-page-button"
      [href]="becomeACustomerUrl"
      target="_self"
    >
      <span>{{ 'i18n.common.becomeACustomer' | translate }}</span>
    </ion-button>
    <ion-button
      class="usf-outline-green-dsktp-tblt-modal-button guest-login-more-page-button"
      data-cy="guest-login-more-page-button"
      (click)="logout()"
    >
      <span>{{ 'i18n.common.logIn' | translate }}</span>
    </ion-button>
  </div>

  <ion-list
    *ngIf="(moreVM$ | async) as moreVM"
    data-cy="more-actions-list"
    class="list-more-mobile"
    lines="none"
  >
    <!-- MAIN MENU -->
    <div class="group" [ngClass]="{ 'is-guest': isGuestUser }">
      <ion-item
        class="btm-line"
        data-cy="more-actions-list-item-products-deals"
        (click)="routeToWithinMoreTab(PATHS.PRODUCTS_DEALS_MENU)"
      >
        <ion-label>{{ 'i18n.more.productsDeals' | translate }}</ion-label>
        <ion-icon name="chevron-forward-outline" slot="end"></ion-icon>
      </ion-item>
      <ion-item
        class="btm-line"
        data-cy="more-actions-list-item-my-business"
        (click)="routeToWithinMoreTab(PATHS.MY_BUSINESS_MENU)"
      >
        <ion-label>{{ 'i18n.more.myBusiness' | translate }}</ion-label>
        <ion-icon name="chevron-forward-outline" slot="end"></ion-icon>
      </ion-item>
      <ion-item
        *ngIf="!isGuestUser"
        class="btm-line"
        data-cy="more-actions-list-item-my-orders"
        (click)="routeToWithinMoreTab(PATHS.MY_ORDERS_MENU)"
      >
        <ion-label>{{ 'i18n.more.myOrders' | translate }}</ion-label>
        <ion-icon name="chevron-forward-outline" slot="end"></ion-icon>
      </ion-item>
      <ion-item
        *ngIf="(serviceRequestFeatureFlag$ | async) && !isGuestUser"
        class="btm-line"
        data-cy="more-actions-list-item-request-credit"
        (click)="routeTo([PATHS.REQUEST_CREDIT])"
      >
        <ion-label
          >{{'i18n.requestCredit.requestCredit' | translate}}</ion-label
        >
      </ion-item>
      <ion-item
        *ngIf="this.chefStoreQREnabled"
        class="btm-line"
        detail="false"
        data-cy="more-actions-list-item-chefstore"
        (click)="openChefStoreQRCodeModal(moreVM?.userId, moreVM?.userName)"
      >
        <div class="new-feature-container">
          <ion-label>{{ 'i18n.more.chefStore' | translate }}</ion-label>
          <ion-chip
            *appShowSplit="[globalChefStoreQRCodeFlag]"
            class="new-feature-chip"
            data-cy="more-actions-list-item-chefstore-new-feature-chip"
            >{{ 'i18n.more.new' | translate }}</ion-chip
          >
        </div>
      </ion-item>
      <ion-item
        *ngIf="showNewsPage"
        [hidden]="!showNewsPage"
        class="btm-line"
        id="newspage-btn"
        data-cy="more-actions-list-item-newspage"
        (click)="routeToNewsPage()"
      >
        <ion-label>{{ newsPageLabel }}</ion-label>
        <ion-icon
          src="assets/icon/external-link-green.svg"
          class="external-link"
          slot="end"
        ></ion-icon>
      </ion-item>
    </div>

    <!-- USER MENU -->
    <div class="group" *ngIf="!isGuestUser">
      <ion-item
        class="btm-line"
        data-cy="more-actions-list-item-profile"
        (click)="routeTo([PATHS.PROFILE])"
      >
        <ion-label>{{ 'i18n.common.myProfile' | translate }}</ion-label>
      </ion-item>
      <ion-item
        *ngIf="(supportCenterFlag$ | async)"
        class="btm-line"
        data-cy="more-actions-list-item-support-center"
        (click)="routeTo([PATHS.SUPPORT_CENTER])"
      >
        <ion-label>{{ 'i18n.supportCenter.title' | translate }}</ion-label>
      </ion-item>
      <ion-item
        *ngIf="!isSuperUser"
        class="btm-line"
        data-cy="more-actions-list-item-upc"
        (click)="openUPC()"
      >
        <ion-label>{{ 'i18n.common.preferenceCenter' | translate }}</ion-label>
      </ion-item>
      <ion-item
        *ngIf="(getInviteNewUserVisibility$ | async) === true"
        class="btm-line"
        data-cy="more-actions-list-item-invite-new-user"
        detail="false"
        (click)="openInviteNewUserModal()"
      >
        <ion-label
          >{{ 'i18n.profilePage.inviteUser.inviteUser' | translate }}</ion-label
        >
      </ion-item>
      <ion-item
        *ngIf="(manageUsersFlag$ | async) && isCustomerAdmin"
        lines="none"
        data-cy="list-actions-user-item-manage-users"
        (click)="routeTo([PATHS.MANAGE_USERS])"
      >
        <ion-label translate>{{ 'i18n.manageUsers.title' }}</ion-label>
      </ion-item>
      <ion-item
        class="btm-line"
        data-cy="more-actions-list-item-help-center"
        detail="false"
        href="https://www.usfoods.com/our-services/moxe-help-center.html"
      >
        <ion-label>{{ 'i18n.more.helpCenter' | translate }}</ion-label>
      </ion-item>
    </div>

    <!-- EXTERNAL LINKS DONE -->
    <div class="group gray-background">
      <ion-item
        class="btm-line gray-background"
        data-cy="more-actions-list-item-terms-of-use"
        detail="false"
        href="https://www.usfoods.com/policies/index.html"
      >
        <ion-label>{{ 'i18n.more.termsOfUse' | translate }}</ion-label>
      </ion-item>
      <ion-item
        class="btm-line gray-background"
        data-cy="more-actions-list-item-privacy"
        detail="false"
        href="https://www.usfoods.com/policies/privacy.html"
      >
        <ion-label>{{ 'i18n.more.chefStorePolicy' | translate }}</ion-label>
      </ion-item>
      <ion-item
        class="btm-line gray-background"
        data-cy="more-actions-list-item-customer"
        detail="false"
        href="https://www.usfoods.com/policies/customer.html"
      >
        <ion-label>{{ 'i18n.more.customerPolicy' | translate }}</ion-label>
      </ion-item>

      <ion-item
        class="btm-line gray-background"
        data-cy="more-actions-list-item-contact"
        detail="false"
        href="https://www.usfoods.com/policies/contact.html"
      >
        <ion-label>{{ 'i18n.more.contactUs' | translate }}</ion-label>
      </ion-item>

      <ion-item
        class="btm-line gray-background"
        data-cy="more-actions-list-item-about"
        detail="false"
        href="https://www.usfoods.com/policies/about.html"
      >
        <ion-label>{{ 'i18n.more.aboutSite' | translate }}</ion-label>
      </ion-item>

      <div
        *ngIf="!isGuestUser"
        class="text-info gray-background"
        data-cy="more-actions-list-item-info"
        detail="false"
      >
        <ion-label>{{ 'i18n.moxe-links.orderInfo' | translate }}</ion-label
        ><br />
        <ion-label>
          <ng-container *ngIf="divisionInfo$ | async; let divisionInfo">
            <ng-container
              *ngIf="
                divisionInfo?.telephoneNumber !== null &&
                divisionInfo?.telephoneNumber !== ''
              "
            >
              <aside
                *ngIf="(divisionPhoneNumber$ | async)?.length === 0"
                data-cy="footer-ordering-info-phone-text"
              >
                <a
                  data-cy="ordering-phone-number-link"
                  [href]="'tel:+1' + divisionInfo?.telephoneNumber"
                >
                  {{ divisionInfo?.telephoneNumber | phoneNumberFormat }}
                </a>
              </aside>
              <aside
                *ngIf="(divisionPhoneNumber$ | async)?.length > 0"
                data-cy="footer-ordering-info-phone-text"
              >
                <a
                  data-cy="footer-phone-link"
                  [href]="'tel:+1' + (divisionPhoneNumber$ | async)"
                >
                  +1 {{ (divisionPhoneNumber$ | async) | phoneNumberFormat }}
                </a>
              </aside>
            </ng-container>
          </ng-container>
        </ion-label>
      </div>

      <div
        *ngIf="!isGuestUser"
        class="text-info gray-background add-margin"
        data-cy="more-actions-list-item-tech-info"
        detail="false"
      >
        <ion-label>{{ 'i18n.moxe-links.techInfo' | translate }}</ion-label>
        <br />
        <a data-cy="tech-phone-number-link" href="tel:+18775839659">
          {{ 'i18n.moxe-links.techInfoNum' | translate }}
        </a>
      </div>

      <ng-container
        *ngIf="(punchoutReturnLinkData$ | async) as punchoutReturnLinkData"
      >
        <ng-container *ngIf="!isGuestUser">
          <ion-item
            *ngIf="punchoutReturnLinkData?.returnLinkFlag === true; else regularLogout"
            class="btm-line gray-background"
            data-cy="more-actions-logout-btn"
            (click)="returnToPartnerSite(punchoutReturnLinkData?.returnLinkUrl)"
          >
            <ion-label class="logout">
              {{ punchoutReturnLinkData.returnLinkText }}
            </ion-label>
            <ion-icon name="exit-outline" slot="end" class="logout"></ion-icon>
          </ion-item>
        </ng-container>
      </ng-container>

      <ng-template #regularLogout>
        <ion-item
          *ngIf="!isGuestUser"
          class="btm-line gray-background"
          data-cy="more-actions-logout-btn"
          (click)="logout()"
        >
          <ion-label class="logout"
            >{{ 'i18n.login.logOut' | translate }}</ion-label
          >
          <ion-icon name="exit-outline" slot="end" class="logout"></ion-icon>
        </ion-item>
      </ng-template>
    </div>
  </ion-list>
</ion-content>
<app-footer></app-footer>
